import React, { useEffect, useRef, useState } from 'react'
import '../../Template/TemplateLogs/TemplateLogs.css'
import '../../Project Management/Project Listing/Projectlisting.css'
import Pagination from '../../Pagination/Pagination';
import { useNavigate } from 'react-router-dom';
import { hideLoader, showLoader } from '../../../Redux/Slice/Loader/loaderSlice';
import { useDispatch, useSelector } from 'react-redux';
import showToast from '../../../Utils/Toast/ToastNotification';
import { HandleApiError } from '../../../Utils/CommonErrors/HandleApiError';
import LogService from '../../../Services/LogService/LogService';
import userManagementService from '../../../Services/UserManagement/UserManagementService';

const AuditLogs = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const startDateRef = useRef(null);
    const endDateRef = useRef(null);

    const [totalRecords, setTotalRecords] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [auditLogs, setAuditLogs] = useState([])
    const [users, setUsers] = useState([]);
    const [filterOptions, setFilterOptions] = useState({
        actions: [],
        entity_types: [],
        sources: ['web', 'mobile'],
    });
    const [isFilterCleared, setIsFilterCleared] = useState(false);
    const [filters, setFilters] = useState({
        action: '',
        entity_type: '',
        performed_by: '',
        source: '',
        start_date: '',
        end_date: '',
    });

    const token = useSelector(
        (state) => state.auth?.user?.data?.body?.data?.token
    );

    const handleChangePage = (newPage) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (e) => {
        setRowsPerPage(e.target.value);
        setPage(0);
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prevFilters) => ({
            ...prevFilters,
            [name]: value,
        }));
    };

    const handleFocus = (ref) => {
        if (ref.current) {
            ref.current.showPicker?.();
        }
    };

    const handleClearFilter = (e) => {
        e.preventDefault();
        setFilters({
            action: '',
            entity_type: '',
            performed_by: '',
            source: '',
            start_date: '',
            end_date: '',
        });
        setPage(0);
        setIsFilterCleared(true);
        if (startDateRef.current) startDateRef.current.value = '';
        if (endDateRef.current) endDateRef.current.value = '';
    };

    const handleFilterSubmit = (e) => {
        e.preventDefault();
        setPage(0);
        getAuditLogsList(0);
    };

    const getUsers = async () => {
        try {
            const response = await userManagementService.getUserList({ limit: 100 }, token);
            if (response?.data?.statusCode === 200) {
                setUsers(response.data.body.data.users || []);
            }
        } catch (error) {
            await HandleApiError(error);
        }
    };

    const getAuditLogsList = async (pageOverride = page) => {
        dispatch(showLoader());
        const params = {
            page: pageOverride + 1,
            limit: rowsPerPage,
            include_filter_options: 'true',
        };

        if (filters.action) params.action = filters.action;
        if (filters.entity_type) params.entity_type = filters.entity_type;
        if (filters.performed_by) params.performed_by = filters.performed_by;
        if (filters.source) params.source = filters.source;
        if (filters.start_date) params.start_date = filters.start_date;
        if (filters.end_date) params.end_date = filters.end_date;

        try {
            const response = await LogService.getAuditLogs(params, token)

            if (response?.data?.statusCode == 200) {
                const logsList = response?.data?.body?.data?.logs || [];
                const totalItems = response?.data?.body?.data?.pagination?.total || 0;
                const options = response?.data?.body?.data?.filterOptions;

                if (options) {
                    setFilterOptions(options);
                }

                if (logsList.length === 0 && pageOverride > 0) {
                    setPage(prev => prev - 1);
                } else {
                    setAuditLogs(logsList)
                    setTotalRecords(totalItems)
                }
            } else {
                showToast("error", response.data.body?.message);
            }
        }
        catch (error) {
            await HandleApiError(error);
        } finally {
            dispatch(hideLoader());
        }
    }

    useEffect(() => {
        getUsers();
    }, []);

    useEffect(() => {
        getAuditLogsList();
    }, [page, rowsPerPage]);

    useEffect(() => {
        if (isFilterCleared) {
            getAuditLogsList(0);
            setIsFilterCleared(false);
        }
    }, [isFilterCleared]);

    return (
        <>
            <div className='main-inner-block'>
                <div className='content'>
                    <div className='d-flex align-items-center justify-content-between mb-4 block-one gap-3'>
                        <div className='heading-content ms-0 mt-0'>
                            Audit Logs
                        </div>
                    </div>
                    <div className='white-box bg-box-mob'>
                        <div className='inner-content-block'>
                            <div className='listing-title-block d-flex justify-content-between'>
                                <div className='box-listing-title'>
                                    Data Change History
                                    <span className='d-block'>
                                        Before/after snapshots for create, update, delete, and archive actions across the web portal.
                                    </span>
                                </div>

                                <div className="searchbar-btn d-flex align-items-center gap-4">
                                    <div className="filter d-flex align-items-center gap-4">
                                        <a
                                            className="filter-inner"
                                            href="#"
                                            data-bs-toggle="modal"
                                            data-bs-target="#auditLogFilterModal"
                                        >
                                            <span className="me-2">
                                                <svg
                                                    width="20"
                                                    height="21"
                                                    viewBox="0 0 20 21"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M5 10.332H15M2.5 5.33203H17.5M7.5 15.332H12.5"
                                                        stroke="#475467"
                                                        strokeWidth="1.5"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </span>
                                            Filter
                                        </a>
                                        <div
                                            className="modal fade"
                                            id="auditLogFilterModal"
                                            tabIndex="-1"
                                            aria-labelledby="auditLogFilterModalLabel"
                                            aria-hidden="true"
                                        >
                                            <div className="modal-dialog modal-dialog-centered">
                                                <div className="modal-content">
                                                    <div className="text-end">
                                                        <button
                                                            type="button"
                                                            className="btn-close"
                                                            data-bs-dismiss="modal"
                                                            aria-label="Close"
                                                        ></button>
                                                    </div>

                                                    <div>
                                                        <h1
                                                            className="modal-title fs-5 text-center filter-title"
                                                            id="auditLogFilterModalLabel"
                                                        >
                                                            Audit Log Filter
                                                        </h1>
                                                    </div>
                                                    <div className="modal-body">
                                                        <form onSubmit={handleFilterSubmit}>
                                                            <div className="mb-3">
                                                                <label htmlFor="auditAction" className="form-label">
                                                                    Action
                                                                </label>
                                                                <select
                                                                    className="form-select"
                                                                    id="auditAction"
                                                                    name="action"
                                                                    value={filters.action}
                                                                    onChange={handleFilterChange}
                                                                >
                                                                    <option value="">Select Action</option>
                                                                    {filterOptions.actions.map((action) => (
                                                                        <option key={action} value={action}>
                                                                            {action}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            <div className="mb-3">
                                                                <label htmlFor="auditEntityType" className="form-label">
                                                                    Entity Type
                                                                </label>
                                                                <select
                                                                    className="form-select"
                                                                    id="auditEntityType"
                                                                    name="entity_type"
                                                                    value={filters.entity_type}
                                                                    onChange={handleFilterChange}
                                                                >
                                                                    <option value="">Select Entity Type</option>
                                                                    {filterOptions.entity_types.map((entityType) => (
                                                                        <option key={entityType} value={entityType}>
                                                                            {entityType}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            <div className="mb-3">
                                                                <label htmlFor="auditPerformedBy" className="form-label">
                                                                    Performed By
                                                                </label>
                                                                <select
                                                                    className="form-select"
                                                                    id="auditPerformedBy"
                                                                    name="performed_by"
                                                                    value={filters.performed_by}
                                                                    onChange={handleFilterChange}
                                                                >
                                                                    <option value="">Select User</option>
                                                                    {users.map((user) => (
                                                                        <option key={user.user_id || user.id} value={user.user_id || user.id}>
                                                                            {`${user.first_name || ''} ${user.last_name || ''}`.trim()}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            <div className="mb-3">
                                                                <label htmlFor="auditSource" className="form-label">
                                                                    Source
                                                                </label>
                                                                <select
                                                                    className="form-select"
                                                                    id="auditSource"
                                                                    name="source"
                                                                    value={filters.source}
                                                                    onChange={handleFilterChange}
                                                                >
                                                                    <option value="">Select Source</option>
                                                                    {filterOptions.sources.map((source) => (
                                                                        <option key={source} value={source}>
                                                                            {source}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>

                                                            <div className="mb-3">
                                                                <label htmlFor="auditStartDate" className="form-label">
                                                                    Start Date
                                                                </label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    id="auditStartDate"
                                                                    name="start_date"
                                                                    ref={startDateRef}
                                                                    value={filters.start_date}
                                                                    onClick={() => handleFocus(startDateRef)}
                                                                    onChange={handleFilterChange}
                                                                />
                                                            </div>

                                                            <div className="mb-3">
                                                                <label htmlFor="auditEndDate" className="form-label">
                                                                    End Date
                                                                </label>
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    id="auditEndDate"
                                                                    name="end_date"
                                                                    ref={endDateRef}
                                                                    value={filters.end_date}
                                                                    onClick={() => handleFocus(endDateRef)}
                                                                    onChange={handleFilterChange}
                                                                />
                                                            </div>

                                                            <div className="text-center">
                                                                <button
                                                                    type="submit"
                                                                    className="green-btn updt-button"
                                                                    data-bs-dismiss="modal"
                                                                    onClick={handleFilterSubmit}
                                                                >
                                                                    Filter
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="green-btn updt-button ms-2"
                                                                    data-bs-dismiss="modal"
                                                                    onClick={handleClearFilter}
                                                                >
                                                                    Clear Filter
                                                                </button>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className='table-block d-none d-md-block'>
                                <table className="table">
                                    <thead className="table-headers">
                                        <tr>
                                            <th>Action</th>
                                            <th>Entity Type</th>
                                            <th>Performed By</th>
                                            <th>Source</th>
                                            <th>Date</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {auditLogs.length > 0 ? (
                                            auditLogs.map((log) => (
                                                <tr key={log.id}>
                                                    <td>{log.action || '-'}</td>
                                                    <td>{log.entity_type || '-'}</td>
                                                    <td>{`${log.first_name || ''} ${log.last_name || ''}`.trim() || '-'}</td>
                                                    <td>{log.source || '-'}</td>
                                                    <td>
                                                        {log.timestamp
                                                            ? new Date(log.timestamp).toLocaleString()
                                                            : "-"}
                                                    </td>
                                                    <td>
                                                        <a
                                                            className="tooltip-container flex align-items-center text-decoration-none fonticon"
                                                            onClick={() => navigate(`/view-audit-logs/${log.id}`)}
                                                        >
                                                            <i className="fas fa-eye me-2"></i>
                                                            <span className="tooltip-text">View Details</span>
                                                        </a>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="6" className="text-center">
                                                    No Audit Logs Found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            <div className="mobile-user-list d-block d-md-none">
                                {auditLogs.length > 0 ? (
                                    auditLogs.map((log) => (
                                        <div key={log.id} className="col-12 mb-4">
                                            <div className="card shadow-sm h-100">
                                                <div className="card-body">
                                                    <p className="mb-1"><strong>Action:</strong> {log.action || '-'}</p>
                                                    <p className="mb-1"><strong>Entity:</strong> {log.entity_type || '-'}</p>
                                                    <p className="mb-1"><strong>Performed By:</strong> {`${log.first_name || ''} ${log.last_name || ''}`.trim() || '-'}</p>
                                                    <p className="mb-1"><strong>Source:</strong> {log.source || '-'}</p>
                                                    <p className="mb-1"><strong>Date:</strong> {log.timestamp ? new Date(log.timestamp).toLocaleString() : '-'}</p>
                                                    <div className="d-flex justify-content-end mt-3">
                                                        <a
                                                            className="text-decoration-none fonticon"
                                                            onClick={() => navigate(`/view-audit-logs/${log.id}`)}
                                                        >
                                                            <i className="fas fa-eye me-2"></i> View
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div className="col-12 text-center">
                                        <div className="alert alert-info">No Audit logs found</div>
                                    </div>
                                )}
                            </div>

                            <div className="pagination-block">
                                <Pagination
                                    count={totalRecords}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onChangePage={handleChangePage}
                                    onRowsPerPageChange={handleRowsPerPageChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AuditLogs
